export const LOCAL_VETSPIRE_URL = `/schedule-appointment/api/vetspire/`;

export enum TagTheme {
	AspenDental = 'aspendental',
	AzPetVet = 'azPetVet',
	TeamTag = 'teamTag',
	WellNow = 'wellnow',
	Chapter = 'chapter',
	ClearChoice = 'clearchoice',
	Lovet = 'lovet',
}

export const SCHEDULING_URL_ATTRIBUTE_NAME = 'Scheduling URL';

export const VETSPIRE_SCHEDULING_KEYWORD = 'book-an-appointment';

export interface IVALID_TYPES {
	key: string;
	lcApptType: string;
	label: string;
	disabled?: boolean;
	showWhenAbsent?: boolean;
}

export const VALID_TYPES: IVALID_TYPES[] = [
	{ key: 'Illness', lcApptType: 'illness', label: 'Illness', disabled: false, showWhenAbsent: true },
	{ key: 'Injury', lcApptType: 'injury', label: 'Injury', disabled: false, showWhenAbsent: true },
	{
		key: 'School / Sport Physical',
		lcApptType: 'school / sport physical',
		label: 'School or sport physical',
		disabled: false,
		showWhenAbsent: true,
	},
	{
		key: 'Workplace',
		lcApptType: 'workplace',
		label: 'Workplace screening or exam',
		disabled: false,
		showWhenAbsent: true,
	},
	{
		key: 'Sexual Health',
		lcApptType: 'sexual health',
		label: 'Sexual Health',
		disabled: false,
		showWhenAbsent: false,
	},
	{ key: 'OTHER', lcApptType: 'other', label: 'Other', disabled: false, showWhenAbsent: true },
];

export const reasonMapping: Record<string, string> = {
	'illness/injury': '1',
	illness: '1',
	injury: '1b',
	'school / sport physical': '2',
	'workplace screening': '3',
	'om-complex': '3',
	'om-standard': '3',
	other: '4',
	'sexual health': '5',
};

// Maps internal appointment types to endpoint tags
export const apptTypeToTagMapping: Record<string, string> = {
	ILLNESS: 'Illness',
	INJURY: 'Injury',
	'SCHOOL / SPORT PHYSICAL': 'School / Sport Physical',
	'OM-COMPLEX': 'OM-COMPLEX',
	'OM-STANDARD': 'OM-STANDARD',
	'SEXUAL HEALTH': 'Sexual Health',
	OTHER: 'Other',
};

// Maps internal appointment types to display tags (for UI)
export const apptTypeToDisplayTagMapping: Record<string, string> = {
	...apptTypeToTagMapping,
	'OM-COMPLEX': 'Workplace screening or exam',
	'OM-STANDARD': 'Workplace screening or exam',
};

export const CACHE_CONTROL_NO_CACHE = 'no-cache, no-store, must-revalidate';
export const SENTRY_DSN =
	'https://d4a37a7de43a4d8680bc4acc4d66b417@o4508615315554304.ingest.us.sentry.io/4509005921976320';

export const typeMapping: Record<string, string> = {
	ILLNESS: 'ILLNESS',
	INJURY: 'INJURY',
	'SCHOOL / SPORT PHYSICAL': 'School / Sport Physical',
	'SCHOOL OR SPORT PHYSICAL': 'School / Sport Physical',
	'OM-COMPLEX': 'OM-COMPLEX',
	'OM-STANDARD': 'OM-STANDARD',
	'SEXUAL HEALTH': 'SEXUAL HEALTH',
	OTHER: 'OTHER',
	// Additional mappings for user-friendly URLs
	'WORKPLACE SCREENING OR EXAM': 'OM-COMPLEX',
};
